export const CredentialedParameters: RequestInit = {
  credentials: 'include',
};
export const CredentialedPostParameters: RequestInit = {
  ...CredentialedParameters,
  method: 'POST',
  headers: {
    vMethod: 'POST',
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

export const CredentialedPutParameters: RequestInit = {
  ...CredentialedParameters,
  method: 'POST',
  headers: {
    vMethod: 'PUT',
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
};

export const LoginPostParameters: RequestInit = {
  ...CredentialedParameters,
  method: 'POST',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
    'V-Platform': 'classic',
  },
};
